export const LANG_ES = "LANG_ES" as const;
export const LANG_EN = "LANG_EN" as const;
export const ES_LANG_ATTRIBUTE_TAG = "es" as const;
export const EN_LANG_ATTRIBUTE_TAG = "en" as const;
export type LANG = typeof LANG_EN | typeof LANG_ES;
export type LANG_ATTRIBUTE_TAG =
  | typeof ES_LANG_ATTRIBUTE_TAG
  | typeof EN_LANG_ATTRIBUTE_TAG;

export const ES_MX_LANGUAGE_CODE = "es-MX" as const;
export const ES_TEXT = "Spanish" as const;
export const EN_TEXT = "English" as const;
export const LANG_TOGGLE_LIST = ["LANG_EN", "LANG_ES"] as const;
export const LANGUAGE_CODE_MAP = {
  es: "LANG_ES",
  en: "LANG_EN",
} as const;
